<template>
    <div>
        <div class="keypad-row">
            <span class="btn-lg btn-secondary" @click="handleKeypad('7')">7</span>
            <span class="btn-lg btn-secondary" @click="handleKeypad('8')">8</span>
            <span class="btn-lg btn-secondary" @click="handleKeypad('9')">9</span>
        </div>
        <div class="keypad-row">
            <span class="btn-lg btn-secondary" @click="handleKeypad('4')">4</span>
            <span class="btn-lg btn-secondary" @click="handleKeypad('5')">5</span>
            <span class="btn-lg btn-secondary" @click="handleKeypad('6')">6</span>
        </div>
        <div class="keypad-row">
            <span class="btn-lg btn-secondary" @click="handleKeypad('1')">1</span>
            <span class="btn-lg btn-secondary" @click="handleKeypad('2')">2</span>
            <span class="btn-lg btn-secondary" @click="handleKeypad('3')">3</span>
        </div>
        <div class="keypad-row">
            <span class="btn-lg btn-secondary" @click="handleKeypad('0')">0</span>
            <span class="btn-lg btn-secondary opacity0">_</span>
            <span class="btn-lg btn-danger clear-button" @click="handleKeypad('C')">C</span>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
export default {
    name: 'keypad',
    data() {
        return {
            initialValue: null,
            clearOnNextInput: true,
            value: null,
        }
    },

    computed: {
    },

    methods: {
        reset(initialValue) {
            this.initialValue = initialValue
            this.clearOnNextInput = true
        },

        handleKeypad(key) {
            if (key == "C") {
                this.value = null

                this.$emit('change', {
                    value: this.value
                })
                return
            }

            const currentValue = this.value || 0
            let nextValue = null

            if (this.clearOnNextInput) {
                nextValue = +key
                this.clearOnNextInput = false
            }
            else {
                nextValue = +("" + currentValue + key)
            }

            console.log("key: " + key)
            console.log("currentValue: " + currentValue)
            console.log("nextValue: " + nextValue)

            this.value = nextValue

            this.$emit('change', {
                value: this.value
            })
        },
    },
}
</script>
